export const DAILY_PUBLISH_PROJECT_BEGIN = 'DAILY_PUBLISH_PROJECT_BEGIN';
export const DAILY_PUBLISH_PROJECT_SUCCESS = 'DAILY_PUBLISH_PROJECT_SUCCESS';
export const DAILY_PUBLISH_PROJECT_FAILURE = 'DAILY_PUBLISH_PROJECT_FAILURE';
export const DAILY_PUBLISH_PROJECT_DISMISS_ERROR = 'DAILY_PUBLISH_PROJECT_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/daily/redux/constants.js